




































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import CostListItem from "@/components/user/list/item/CostListItem.vue";
import { ICost, ICostListRequest, IDailyCost } from "@/types/cost";
import { IPagination } from "@/types";

@Component({
  components: { CostListItem }
})
export default class extends Vue {
  @Action("cost/getList")
  public getList!: (params: ICostListRequest) => void;

  @Getter("cost/siteDailyCost")
  public siteDailyCost!: IDailyCost[];

  @Getter("cost/pagination")
  public pagination!: IPagination<ICost>;

  @Mutation("cost/clear")
  public clear!: () => void;

  @Watch("params.page")
  public async changePage() {
    await this.getList(this.params);
  }

  public site_id = 0;
  public params: ICostListRequest = {
    site_id: 0,
    page: 1,
    per_page: 10,
    is_today: true
  };

  //--------
  // 作成時に実行
  public async created() {
    this.site_id = Number(this.$route.params.site_id);
    this.params.site_id = this.site_id;
    this.clear();
    await this.getList(this.params);
  }
  public goToHome() {
    this.$router.push(`/site/list`);
  }
}
